import { KeysEnum } from '../../../../common/utils/types';
import { modelEntityViewRouteParamKeys, ModelEntityViewRouteParams } from '../types';

export interface ProductViewRouteParams extends ModelEntityViewRouteParams {
  drilldownMode?: string;
  selection?: string;
}

export const ProductViewRouteParamKeys: KeysEnum<ProductViewRouteParams> = {
  ...modelEntityViewRouteParamKeys,
  drilldownMode: 'drilldownMode',
  selection: 'selection',
};
